export default __webpack_public_path__ + "static/media/turquoise-left.bdafb852.svg";